import { render } from "./WatchDashboard.vue?vue&type=template&id=deed4eb0&scoped=true"
import script from "./WatchDashboard.vue?vue&type=script&lang=js"
export * from "./WatchDashboard.vue?vue&type=script&lang=js"

import "./WatchDashboard.vue?vue&type=style&index=0&id=deed4eb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deed4eb0"]])

export default __exports__